import { render, staticRenderFns } from "./cargoSelect.vue?vue&type=template&id=5b4a10fe&"
import script from "./cargoSelect.vue?vue&type=script&lang=js&"
export * from "./cargoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4a10fe')) {
      api.createRecord('5b4a10fe', component.options)
    } else {
      api.reload('5b4a10fe', component.options)
    }
    module.hot.accept("./cargoSelect.vue?vue&type=template&id=5b4a10fe&", function () {
      api.rerender('5b4a10fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/cargoSelect.vue"
export default component.exports